var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#F6F7FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.7947 19.1545C29.6121 16.3917 28.2421 13.8116 26.073 12.0992C23.9039 10.3867 21.0726 9.67889 18.3327 10.1355C13.4465 10.9804 9.86177 15.5012 10.2043 20.4788C10.3641 22.8762 11.3687 25.091 13.0584 26.7806C12.6245 27.4199 12.2364 27.8309 11.2089 28.6529C11.0034 28.8127 10.9121 29.0639 10.9806 29.315C11.0262 29.5662 11.2089 29.7717 11.4372 29.8402C11.7797 29.9544 12.282 30 12.8529 30C14.063 30 15.5928 29.726 16.7801 29.1095C18.3555 29.6575 20.0452 29.7945 21.712 29.4977C26.5982 28.6301 30.1372 24.0863 29.7947 19.1545ZM15.433 21.5976C14.5425 21.5976 13.8347 20.8898 13.8347 19.9993C13.8347 19.1088 14.5425 18.401 15.433 18.401C16.3234 18.401 17.0313 19.1088 17.0313 19.9993C17.0313 20.8898 16.3234 21.5976 15.433 21.5976ZM19.9995 21.5976C19.109 21.5976 18.4012 20.8898 18.4012 19.9993C18.4012 19.1088 19.109 18.401 19.9995 18.401C20.89 18.401 21.5978 19.1088 21.5978 19.9993C21.5978 20.8898 20.89 21.5976 19.9995 21.5976ZM24.5661 21.5976C23.6756 21.5976 22.9678 20.8898 22.9678 19.9993C22.9678 19.1088 23.6756 18.401 24.5661 18.401C25.4565 18.401 26.1643 19.1088 26.1643 19.9993C26.1643 20.8898 25.4565 21.5976 24.5661 21.5976Z",
    fill: "#4B9BF5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage3);
export default __webpack_public_path__ + "static/media/message3.0ec53e8d5b62777c874ba33c1a5f5f1a.svg";
export { ForwardRef as ReactComponent };